import React from 'react'
import { useRemoteConfigBoolean } from 'reactfire'
import { navigateToUrl } from 'single-spa'

import ErrorPage from 'pages/DefaultErrorPage/DefaultErrorPage'

import { Loading } from 'components/Loading/Loading'

import { FeatureFlag } from 'constants/featureFlags'

import MagClass from 'assets/mag-glass.svg'
import Exclamation from 'assets/exclamation-mark.svg'

export default function PageNotFound() {
  const { status, data: releaseNewLayout } = useRemoteConfigBoolean(
    FeatureFlag.RELEASE_NOVO_LAYOUT_NAOENCOTRADO,
  )

  if (status === 'loading') {
    return <Loading />
  }

  if (releaseNewLayout) {
    return (
      <ErrorPage
        img={{
          src: Exclamation,
          alt: 'exclamação',
        }}
        action="Não encontrei a página solicitada"
        body="Parece que essa página não está mais disponível. Vamos ir para a página inicial?"
        button={{
          text: 'Ir para página inicial',
          onClick: () => navigateToUrl('/'),
        }}
      />
    )
  }

  return (
    <ErrorPage
      img={{
        src: MagClass,
        alt: 'lupa',
      }}
      action="Não encontrei essa página"
      body="Parece que essa página não está mais disponível. Vamos ir para a página inicial?"
      button={{
        text: 'Ir para página inicial',
        onClick: () => navigateToUrl('/'),
      }}
    />
  )
}
